import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../Enum.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../js/void.mjs';
import {
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../exceptions.mjs';
import {
  _Char___init__impl__6a9atx1csff5kwtduxl as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixd3jl92hthlhyn7 as Char__toInt_impl_vasixd,
} from '../../Char.mjs';
import {
  toByte4i43936u611k as toByte,
  numberToChar93r9buh19yek as numberToChar,
} from '../../js/numberConversion.mjs';
import { toString1pkumu07cwy4m as toString } from '../../js/coreRuntime.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../text/StringBuilderJs.mjs';
import { Companion_instance1a0yry1hi33tg as Companion_instance } from '../../collections/AbstractList.mjs';
import { fill2542d4m9l93pn as fill } from '../../collections/_ArraysJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_base64EncodeMap() {
  _init_properties_Base64_kt__ymmsz3();
  return base64EncodeMap;
}
var base64EncodeMap;
var base64DecodeMap;
function get_base64UrlEncodeMap() {
  _init_properties_Base64_kt__ymmsz3();
  return base64UrlEncodeMap;
}
var base64UrlEncodeMap;
var base64UrlDecodeMap;
var PaddingOption_PRESENT_instance;
var PaddingOption_ABSENT_instance;
var PaddingOption_PRESENT_OPTIONAL_instance;
var PaddingOption_ABSENT_OPTIONAL_instance;
var PaddingOption_entriesInitialized;
function PaddingOption_initEntries() {
  if (PaddingOption_entriesInitialized)
    return Unit_instance;
  PaddingOption_entriesInitialized = true;
  PaddingOption_PRESENT_instance = new (PaddingOption())('PRESENT', 0);
  PaddingOption_ABSENT_instance = new (PaddingOption())('ABSENT', 1);
  PaddingOption_PRESENT_OPTIONAL_instance = new (PaddingOption())('PRESENT_OPTIONAL', 2);
  PaddingOption_ABSENT_OPTIONAL_instance = new (PaddingOption())('ABSENT_OPTIONAL', 3);
}
var PaddingOptionClass;
function PaddingOption() {
  if (PaddingOptionClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'PaddingOption');
    PaddingOptionClass = $;
  }
  return PaddingOptionClass;
}
function shouldPadOnEncode($this) {
  return $this.an_1.equals(PaddingOption_PRESENT_getInstance()) || $this.an_1.equals(PaddingOption_PRESENT_OPTIONAL_getInstance());
}
function checkDestinationBounds($this, destinationSize, destinationOffset, capacityNeeded) {
  if (destinationOffset < 0 || destinationOffset > destinationSize) {
    throw IndexOutOfBoundsException().n3('destination offset: ' + destinationOffset + ', destination size: ' + destinationSize);
  }
  var destinationEndIndex = destinationOffset + capacityNeeded | 0;
  if (destinationEndIndex < 0 || destinationEndIndex > destinationSize) {
    throw IndexOutOfBoundsException().n3('The destination array does not have enough capacity, ' + ('destination offset: ' + destinationOffset + ', destination size: ' + destinationSize + ', capacity needed: ' + capacityNeeded));
  }
}
var DefaultClass;
function Default() {
  if (DefaultClass === VOID) {
    class $ extends Base64() {
      constructor() {
        Default_instance = null;
        super(false, false, -1, PaddingOption_PRESENT_getInstance());
        Default_instance = this;
        this.hn_1 = 8;
        this.in_1 = 6;
        this.jn_1 = 3;
        this.kn_1 = 4;
        this.ln_1 = 61;
        this.mn_1 = 76;
        this.nn_1 = 64;
        var tmp = this;
        // Inline function 'kotlin.code' call
        var this_0 = _Char___init__impl__6a9atx(13);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var tmp_0 = toByte(tmp$ret$0);
        // Inline function 'kotlin.code' call
        var this_1 = _Char___init__impl__6a9atx(10);
        var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
        // Inline function 'kotlin.byteArrayOf' call
        tmp.on_1 = new Int8Array([tmp_0, toByte(tmp$ret$1)]);
        this.pn_1 = new (Base64())(true, false, -1, PaddingOption_PRESENT_getInstance());
        this.qn_1 = new (Base64())(false, true, 76, PaddingOption_PRESENT_getInstance());
        this.rn_1 = new (Base64())(false, true, 64, PaddingOption_PRESENT_getInstance());
      }
    }
    initMetadataForObject($, 'Default');
    DefaultClass = $;
  }
  return DefaultClass;
}
var Default_instance;
function Default_getInstance() {
  if (Default_instance === VOID)
    new (Default())();
  return Default_instance;
}
function PaddingOption_PRESENT_getInstance() {
  PaddingOption_initEntries();
  return PaddingOption_PRESENT_instance;
}
function PaddingOption_PRESENT_OPTIONAL_getInstance() {
  PaddingOption_initEntries();
  return PaddingOption_PRESENT_OPTIONAL_instance;
}
var Base64Class;
function Base64() {
  if (Base64Class === VOID) {
    class $ {
      constructor(isUrlSafe, isMimeScheme, mimeLineLength, paddingOption) {
        Default_getInstance();
        this.xm_1 = isUrlSafe;
        this.ym_1 = isMimeScheme;
        this.zm_1 = mimeLineLength;
        this.an_1 = paddingOption;
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.require' call
        if (!(!this.xm_1 || !this.ym_1)) {
          var message = 'Failed requirement.';
          throw IllegalArgumentException().s2(toString(message));
        }
        this.bn_1 = this.zm_1 / 4 | 0;
      }
      sn(source, startIndex, endIndex) {
        // Inline function 'kotlin.io.encoding.platformEncodeToString' call
        var byteResult = this.un(source, startIndex, endIndex);
        return this.xn(byteResult);
      }
      tn(source, startIndex, endIndex, $super) {
        startIndex = startIndex === VOID ? 0 : startIndex;
        endIndex = endIndex === VOID ? source.length : endIndex;
        return $super === VOID ? this.sn(source, startIndex, endIndex) : $super.sn.call(this, source, startIndex, endIndex);
      }
      un(source, startIndex, endIndex) {
        this.yn(source.length, startIndex, endIndex);
        var encodeSize = this.wn(endIndex - startIndex | 0);
        var destination = new Int8Array(encodeSize);
        this.vn(source, destination, 0, startIndex, endIndex);
        return destination;
      }
      vn(source, destination, destinationOffset, startIndex, endIndex) {
        this.yn(source.length, startIndex, endIndex);
        checkDestinationBounds(this, destination.length, destinationOffset, this.wn(endIndex - startIndex | 0));
        var encodeMap = this.xm_1 ? get_base64UrlEncodeMap() : get_base64EncodeMap();
        var sourceIndex = startIndex;
        var destinationIndex = destinationOffset;
        var groupsPerLine = this.ym_1 ? this.bn_1 : 2147483647;
        while ((sourceIndex + 2 | 0) < endIndex) {
          // Inline function 'kotlin.comparisons.minOf' call
          var a = (endIndex - sourceIndex | 0) / 3 | 0;
          var groups = Math.min(a, groupsPerLine);
          var inductionVariable = 0;
          if (inductionVariable < groups)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var _unary__edvuaz = sourceIndex;
              sourceIndex = _unary__edvuaz + 1 | 0;
              var byte1 = source[_unary__edvuaz] & 255;
              var _unary__edvuaz_0 = sourceIndex;
              sourceIndex = _unary__edvuaz_0 + 1 | 0;
              var byte2 = source[_unary__edvuaz_0] & 255;
              var _unary__edvuaz_1 = sourceIndex;
              sourceIndex = _unary__edvuaz_1 + 1 | 0;
              var byte3 = source[_unary__edvuaz_1] & 255;
              var bits = byte1 << 16 | byte2 << 8 | byte3;
              var _unary__edvuaz_2 = destinationIndex;
              destinationIndex = _unary__edvuaz_2 + 1 | 0;
              destination[_unary__edvuaz_2] = encodeMap[bits >>> 18 | 0];
              var _unary__edvuaz_3 = destinationIndex;
              destinationIndex = _unary__edvuaz_3 + 1 | 0;
              destination[_unary__edvuaz_3] = encodeMap[(bits >>> 12 | 0) & 63];
              var _unary__edvuaz_4 = destinationIndex;
              destinationIndex = _unary__edvuaz_4 + 1 | 0;
              destination[_unary__edvuaz_4] = encodeMap[(bits >>> 6 | 0) & 63];
              var _unary__edvuaz_5 = destinationIndex;
              destinationIndex = _unary__edvuaz_5 + 1 | 0;
              destination[_unary__edvuaz_5] = encodeMap[bits & 63];
            }
             while (inductionVariable < groups);
          if (groups === groupsPerLine && !(sourceIndex === endIndex)) {
            var _unary__edvuaz_6 = destinationIndex;
            destinationIndex = _unary__edvuaz_6 + 1 | 0;
            destination[_unary__edvuaz_6] = Default_getInstance().on_1[0];
            var _unary__edvuaz_7 = destinationIndex;
            destinationIndex = _unary__edvuaz_7 + 1 | 0;
            destination[_unary__edvuaz_7] = Default_getInstance().on_1[1];
          }
        }
        var tmp0_subject = endIndex - sourceIndex | 0;
        if (tmp0_subject === 1) {
          var _unary__edvuaz_8 = sourceIndex;
          sourceIndex = _unary__edvuaz_8 + 1 | 0;
          var byte1_0 = source[_unary__edvuaz_8] & 255;
          var bits_0 = byte1_0 << 4;
          var _unary__edvuaz_9 = destinationIndex;
          destinationIndex = _unary__edvuaz_9 + 1 | 0;
          destination[_unary__edvuaz_9] = encodeMap[bits_0 >>> 6 | 0];
          var _unary__edvuaz_10 = destinationIndex;
          destinationIndex = _unary__edvuaz_10 + 1 | 0;
          destination[_unary__edvuaz_10] = encodeMap[bits_0 & 63];
          if (shouldPadOnEncode(this)) {
            var _unary__edvuaz_11 = destinationIndex;
            destinationIndex = _unary__edvuaz_11 + 1 | 0;
            destination[_unary__edvuaz_11] = 61;
            var _unary__edvuaz_12 = destinationIndex;
            destinationIndex = _unary__edvuaz_12 + 1 | 0;
            destination[_unary__edvuaz_12] = 61;
          }
        } else if (tmp0_subject === 2) {
          var _unary__edvuaz_13 = sourceIndex;
          sourceIndex = _unary__edvuaz_13 + 1 | 0;
          var byte1_1 = source[_unary__edvuaz_13] & 255;
          var _unary__edvuaz_14 = sourceIndex;
          sourceIndex = _unary__edvuaz_14 + 1 | 0;
          var byte2_0 = source[_unary__edvuaz_14] & 255;
          var bits_1 = byte1_1 << 10 | byte2_0 << 2;
          var _unary__edvuaz_15 = destinationIndex;
          destinationIndex = _unary__edvuaz_15 + 1 | 0;
          destination[_unary__edvuaz_15] = encodeMap[bits_1 >>> 12 | 0];
          var _unary__edvuaz_16 = destinationIndex;
          destinationIndex = _unary__edvuaz_16 + 1 | 0;
          destination[_unary__edvuaz_16] = encodeMap[(bits_1 >>> 6 | 0) & 63];
          var _unary__edvuaz_17 = destinationIndex;
          destinationIndex = _unary__edvuaz_17 + 1 | 0;
          destination[_unary__edvuaz_17] = encodeMap[bits_1 & 63];
          if (shouldPadOnEncode(this)) {
            var _unary__edvuaz_18 = destinationIndex;
            destinationIndex = _unary__edvuaz_18 + 1 | 0;
            destination[_unary__edvuaz_18] = 61;
          }
        }
        // Inline function 'kotlin.check' call
        if (!(sourceIndex === endIndex)) {
          throw IllegalStateException().o('Check failed.');
        }
        return destinationIndex - destinationOffset | 0;
      }
      wn(sourceSize) {
        var groups = sourceSize / 3 | 0;
        var trailingBytes = sourceSize % 3 | 0;
        var size = imul(groups, 4);
        if (!(trailingBytes === 0)) {
          size = size + (shouldPadOnEncode(this) ? 4 : trailingBytes + 1 | 0) | 0;
        }
        if (size < 0) {
          throw IllegalArgumentException().s2('Input is too big');
        }
        if (this.ym_1) {
          size = size + imul((size - 1 | 0) / this.zm_1 | 0, 2) | 0;
        }
        if (size < 0) {
          throw IllegalArgumentException().s2('Input is too big');
        }
        return size;
      }
      xn(source) {
        var stringBuilder = StringBuilder().yb(source.length);
        var inductionVariable = 0;
        var last = source.length;
        while (inductionVariable < last) {
          var byte = source[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          stringBuilder.t1(numberToChar(byte));
        }
        return stringBuilder.toString();
      }
      yn(sourceSize, startIndex, endIndex) {
        Companion_instance.eh(startIndex, endIndex, sourceSize);
      }
    }
    initMetadataForClass($, 'Base64');
    Base64Class = $;
  }
  return Base64Class;
}
var properties_initialized_Base64_kt_5g824v;
function _init_properties_Base64_kt__ymmsz3() {
  if (!properties_initialized_Base64_kt_5g824v) {
    properties_initialized_Base64_kt_5g824v = true;
    // Inline function 'kotlin.byteArrayOf' call
    base64EncodeMap = new Int8Array([65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 43, 47]);
    // Inline function 'kotlin.apply' call
    var this_0 = new Int32Array(256);
    fill(this_0, -1);
    this_0[61] = -2;
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var indexedObject = get_base64EncodeMap();
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      this_0[item] = _unary__edvuaz;
    }
    base64DecodeMap = this_0;
    // Inline function 'kotlin.byteArrayOf' call
    base64UrlEncodeMap = new Int8Array([65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 45, 95]);
    // Inline function 'kotlin.apply' call
    var this_1 = new Int32Array(256);
    fill(this_1, -1);
    this_1[61] = -2;
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index_0 = 0;
    var indexedObject_0 = get_base64UrlEncodeMap();
    var inductionVariable_0 = 0;
    var last_0 = indexedObject_0.length;
    while (inductionVariable_0 < last_0) {
      var item_0 = indexedObject_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var _unary__edvuaz_0 = index_0;
      index_0 = _unary__edvuaz_0 + 1 | 0;
      this_1[item_0] = _unary__edvuaz_0;
    }
    base64UrlDecodeMap = this_1;
  }
}
//region block: exports
export {
  Default_getInstance as Default_getInstance67416qwj1tmc,
};
//endregion

//# sourceMappingURL=Base64.mjs.map
